import dynamic from 'next/dynamic';

const TelevetProductSection = dynamic(
  () => import('televet/TelevetProductSection'),
);

export const TelevetSection = () => {
  return <TelevetProductSection />;
};
